import { showSuiErrorSnackbar, showSuiSuccessSnackbar } from "components/SuiSnackbar";

// The app's success and error notifications: a title and a line under it, which may be empty.
export function notifySuccess(title: string, description = "", fallbackTitle = "") {
  showSuiSuccessSnackbar(description || title, { title: description ? title : fallbackTitle });
}

export function notifyError(title: string, description: string) {
  showSuiErrorSnackbar(description, { title, icon: "error_outline" });
}
